import { Container, Modal } from "react-bootstrap";
import PrimaryButton from "../../../util/Btns/PrimaryButton";
import constant from "../../../constant";

import styles from "./RemarksModal.module.scss";
import Close from "../../../Assets/close.svg";

const RemarksModal = ({ showRemarks, setShowRemarks, build }) => {
  const handleClose = () => setShowRemarks(false);
  const formatMessage = (message) => {
    let messageString = '' 
    if(message){
        if(message !== constant.VALIDATION_MESSAGE.DOMAIN_RELEASE_MISMATCH && message.indexOf(constant.VALIDATION_REGEX.APP_URL_VALIDATION) > -1){
          messageString = constant.VALIDATION_MESSAGE.APP_URL_VALIDATION_FAIL
        }
        else {
          messageString = message
        }
      return messageString
    }
  }

  return (
    <>
      <Container>
        <Modal
          show={showRemarks}
          onHide={handleClose}
          centered
          contentClassName={styles.content}
          dialogClassName={styles.dialog}
        >
          <Modal.Body>
            <div className={styles.body}>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  width: "100%",
                }}
              >
                <h3>{build.version} Remarks</h3>
                <img
                  onClick={() => setShowRemarks(false)}
                  src={Close}
                  height="14"
                  width="14"
                  alt="cross"
                  className="cursor-pointer"
                />
              </div>
              {/* <h4>Reasons why your app was rejected:</h4>
              <ul>
                {build.remarks.reasons.map((reason) => (
                  <li>-{reason}</li>
                ))}
              </ul>
              <h4>How you can fix it:</h4>
              <ul>
                {build.remarks.fix.map((fix) => (
                  <li>-{fix}</li>
                ))}
              </ul> */}
              <div className="py-4">{formatMessage(build.comment)}</div>
              <PrimaryButton onClick={() => setShowRemarks(false)}>
                Ok
              </PrimaryButton>
              {/* </div> */}
            </div>
          </Modal.Body>
        </Modal>
      </Container>
    </>
  );
};

export default RemarksModal;
